query LeadsMaster($input: LeadsInput!) {
    leadsMaster(input: $input) {
        total
        hasMore
        entries {
            id
            email
            firstname
            lastname
            createdAt
            lastConversionAt
            currentStatus
            company {
                id
                name
            }
            conversions {
                id
                type
                landingpage {
                    type
                }
                download {
                    postalShipping
                }
                preConversion {
                    id
                    type
                }
                valuation {
                    id
                    inputs {
                        type
                        subType
                        address {
                            street
                            houseNumber
                            city
                            zip
                        }
                    }
                    results {
                        currency
                        property {
                            value
                        }
                    }
                }
                propertyRequest {
                    availableStartDate
                }
            }
        }
    }
}
